import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';

/**
 * Resolves `/` on a custom docs host to `/docs/{spaceId}` via the public domain-access API.
 * Apex install (e.g. dawsha.io) falls through to /login when the host is not a configured space domain.
 */
export default function RootEntryPage() {
  const [searchParams] = useSearchParams();
  const [decision, setDecision] = useState(null); // { type: 'docs', spaceId } | { type: 'login' }

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    const accessToken = searchParams.get('access_token');
    const qs = accessToken ? `?access_token=${encodeURIComponent(accessToken)}` : '';
    const url = `${API_URL}/domain-access/${encodeURIComponent(host)}/space${qs}`;

    axios
      .get(url, { validateStatus: (s) => s === 200 || s === 401 || s === 404 })
      .then((res) => {
        if (res.status === 200 && res.data?.id) {
          setDecision({ type: 'docs', spaceId: res.data.id });
        } else {
          setDecision({ type: 'login' });
        }
      })
      .catch(() => setDecision({ type: 'login' }));
  }, [searchParams.toString()]);

  if (!decision) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600 dark:text-slate-400">Loading…</p>
        </div>
      </div>
    );
  }

  if (decision.type === 'docs') {
    return <Navigate to={`/docs/${decision.spaceId}`} replace />;
  }

  return <Navigate to="/login" replace />;
}
